import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Box, Typography } from '@material-ui/core';
import BuzzInput from '../BuzzInput/BuzzInput';

const CustomBuzzInput = withStyles((theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      // background: 'transparent',
      opacity: 0.99999,
    },
    '& .MuiSelect-root': {
      '&:focus': {
        background: 'transparent',
      },
    },
  },
}))(BuzzInput);

export default function BuzzSelect({
  defaultValue = undefined,
  defaultLabel = '',
  options = [],
  labelKey = 'label',
  valueKey = 'value',
  placeholder = '',
  variant = 'outlined',
  onChange,
  fullWidth = true,
  disabled = false,
  classes,
  value = '',
  id = new Date().toString() + Math.random() * 10000,
  required = false,
  label = '',
  flex = 1,
  autoFocus = false,
  name,
  onBlur,
  onFocus,
  error,
  helperText,
  size,
  width,
  mr,
  ml,
  mb,
  mt,
  mx,
  my,
  m,
  p,
  pl,
  pr,
  px,
  py,
  pt,
  pb,
  bgcolor,
  ...props
}) {
  return (
    <CustomBuzzInput
      placeholder={placeholder}
      variant={variant}
      fullWidth={fullWidth}
      disabled={disabled}
      classes={classes}
      id={id}
      flex={flex}
      autoFocus={autoFocus}
      name={name}
      onBlur={onBlur}
      onFocus={onFocus}
      error={error}
      helperText={helperText}
      size={size}
      width={width}
      mr={mr}
      ml={ml}
      mb={mb}
      mt={mt}
      mx={mx}
      my={my}
      m={m}
      p={p}
      pl={pl}
      pr={pr}
      px={px}
      py={py}
      pt={pt}
      pb={pb}
      value={value}
      onChange={onChange}
      select
      label={label}
      required={required}
      bgcolor={bgcolor}
      InputProps={{
        startAdornment:
          placeholder && !value ? (
            <Box
              ml={1}
              style={{
                zIndex: -1,
                position: 'absolute',
                left: 0,
                cursor: 'pointer',
              }}>
              <Typography
                style={{ fontSize: 14, color: '#A0A0A0' }}
                color="textSecondary">
                {placeholder}
              </Typography>
            </Box>
          ) : null,
      }}
      {...props}>
      {Array.isArray(options) &&
        options.length > 0 &&
        options.map((option) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option[labelKey]}
          </MenuItem>
        ))}
    </CustomBuzzInput>
  );
}
